// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"125":"f2f7b70d","353":"53c7af39","967":"f96e6abf"}[chunkId] + ".js";
};